import React, { useState, useCallback, useRef, useEffect } from 'react';

import DataGrid, { Selection, RowDragging, Column, Editing, Scrolling, Paging, Toolbar, Item, MasterDetail, Export, Summary, TotalItem, FilterRow } from 'devextreme-react/data-grid';
import DropDownButton, { DropDownButtonTypes } from 'devextreme-react/drop-down-button';
import { withLoadPanel } from '../../../utils/withLoadPanel';
import TextBox from 'devextreme-react/text-box';
import './CardEntriesRelay.scss';

import { checkPermission } from '../../../permissions';
import { EditCellTimeComponent, EditCellTimeRender, editCellTimeRender, TimeBox, TimeBoxBold } from '../../utils/time-box/TimeBox';
import { Button, ButtonGroup, NumberBox } from 'devextreme-react';
import { PerformanceCell } from '../../utils/performance-cell/PerformanceCell';
import { useScreenSize } from '../../../utils/media-query';
import { COMPETITION_ATHLETE_STATUS_LIST, COMPETITION_STATUS_LIST, exportFormats, GENDERS } from '../../../shared/constants';
import { onExporting } from '../../../utils/exporter';
import { useNavigate } from 'react-router-dom';
import { FormEntryPopup } from '../../utils/form-entry-popup/FormEntryPopup';
import { EntryRelayForm } from '../entry-relay-form/EntryRelayForm';
import { BatchEntryForm } from '../entry-batch-form/EntryBatchForm';
import { getApiToken } from '../../../utils/authUtils.js';
import axios from 'axios';
import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';
import { CompetitionAthleteStatus } from '../../utils/competition-athlete-status/CompetitionAthleteStatus';
import { useMsal } from "@azure/msal-react";
import SelectBox from 'devextreme-react/select-box';


const Grid = ({ EntriesRelay, competitionId, athletes, competition }) => {
      const { instance, accounts } = useMsal();
    let newEntryData;

    const [popupEntryRelayVisible, setPopupEntryRelayVisible] = useState(false);

    const [entryData, setEntryData] = useState({});

    const { isXSmall } = useScreenSize();
    const onDataChanged = useCallback((data) => {

        newEntryData = data;
    }, []);

    const saveEntryRelay = useCallback((e) => {
        getApiToken(instance, accounts).then((token) => {
            if (e != undefined) {
                newEntryData.status = e;
            }else{
                newEntryData.status = 'offen';
            }
            axios.post(`${process.env.REACT_APP_serverEndpoint}/Entry/SetEntryRelay`, newEntryData, {
                headers: {
                    'Authorization': "Bearer " + token
                }
            }).then((response) => {
                if (response.data.success == true) {

                    if (response.data.result_set == false) {
                        const message = response.data.userMessage || "Meldung konnte nicht gespeichert werden. Möchten Sie es trotzdem versuchen?";
                        confirm(message, "Bestätigung").then((dialogResult) => {
                            if (dialogResult) {
                                // Erneute Anfrage mit force = true
                                axios.post(`${process.env.REACT_APP_serverEndpoint}/Entry/SetEntryRelay`,
                                    { ...newEntryData, force: true },
                                    {
                                        headers: {
                                            'Authorization': "Bearer " + token
                                        }
                                    }
                                ).then((retryResponse) => {
                                    if (retryResponse.data.success == true) {
                                        notify({
                                            message: `Speichern der Meldungen erfolgreich`,
                                            position: { at: 'bottom center', my: 'bottom center' }
                                        }, 'success');
                                        setPopupEntryRelayVisible(false);
                                        gridRef.current?.instance().getDataSource().reload();
                                    } else {
                                        notify({
                                            message: `Fehler beim erneuten Speichern der Meldungen`,
                                            position: { at: 'bottom center', my: 'bottom center' }
                                        }, 'error');
                                    }
                                }).catch((error) => console.log(error));
                            }
                        });
                    } else {
                        notify({
                            message: `Speichern der Meldungen erfolgreich`,
                            position: { at: 'bottom center', my: 'bottom center' }
                        },
                            'success'
                        );
                        setPopupEntryRelayVisible(false)
                        gridRef.current?.instance().getDataSource().reload();
                    }

                } else {
                    notify({
                        message: `Fehler beim Speichern der Meldungen`,
                        position: { at: 'bottom center', my: 'bottom center' }
                    },
                        'error'
                    );
                }

            }
            ).catch((error) => console.log(error));
        });



    }, []);

    const changePopupEntryRelayVisibility = useCallback((isVisble) => {
        setPopupEntryRelayVisible(isVisble);
    }, []);


    const EntryRelayFormWithLoadPanel = withLoadPanel(EntryRelayForm);

    const [gridData, setGridData] = useState(EntriesRelay);


    const gridRef = useRef(null);


    const navigate = useNavigate();

    const onCellClick = useCallback((e) => {

        if (e.rowType === 'data' && e.column.type != 'selection') {

            //LoadEntrieData  e.data.competitionId, e.data.athleteId
            getApiToken(instance, accounts).then((token) => {
                axios.get(`${process.env.REACT_APP_serverEndpoint}/Entry/GetEntryRelay?entryRelayId=` + e.data.entryRelayId.toString() + '&competitionId=' + competitionId, {
                    headers: {
                        'Authorization': "Bearer " + token
                    }
                }).then((response) => {
                    if (response.data.success == true) {
                        newEntryData = response.data.result_set;
                        setEntryData(response.data.result_set)
                        setPopupEntryRelayVisible(true);

                    } else {
                        notify({
                            message: `Fehler beim Laden der Meldungen`,
                            position: { at: 'bottom center', my: 'bottom center' }
                        },
                            'error'
                        );
                    }

                }
                ).catch((error) => console.log(error));
            });


        }
    }, []);
    const onInsertEntryClick = useCallback((e) => {

        getApiToken(instance, accounts).then((token) => {
            axios.get(`${process.env.REACT_APP_serverEndpoint}/Entry/GetEntryRelay?&competitionId=` + competitionId, {
                headers: {
                    'Authorization': "Bearer " + token
                }
            }).then((response) => {
                if (response.data.success == true) {
                    newEntryData = response.data.result_set;
                    setEntryData(response.data.result_set)
                    setPopupEntryRelayVisible(true);

                } else {
                    notify({
                        message: `Fehler beim Laden der Meldungen`,
                        position: { at: 'bottom center', my: 'bottom center' }
                    },
                        'error'
                    );
                }

            }
            ).catch((error) => console.log(error));
        });
      
    }, []);

    const DeleteEntryRelay = useCallback((entryRelayId) => {
        getApiToken(instance, accounts).then((token) => {
            axios.delete(`${process.env.REACT_APP_serverEndpoint}/Entry/DeleteEntryRelay?entryRelayId=${entryRelayId}`, {
                headers: {
                    'Authorization': "Bearer " + token
                }
            }).then((response) => {
                if (response.data.success) {
                    notify({
                        message: `Eintrag erfolgreich gelöscht`,
                        position: { at: 'bottom center', my: 'bottom center' }
                    }, 'success');
                    gridRef.current?.instance().getDataSource().reload(); // Aktualisiere die Tabelle
                } else {
                    notify({
                        message: `Fehler beim Löschen des Eintrags`,
                        position: { at: 'bottom center', my: 'bottom center' }
                    }, 'error');
                }
            }).catch((error) => {
                console.log(error);
                notify({
                    message: `Fehler beim Löschen des Eintrags`,
                    position: { at: 'bottom center', my: 'bottom center' }
                }, 'error');
            });
        });
    }, []);
    const statusItemRender = (text) => <CompetitionAthleteStatus text={text} />;
    return (
        <div className='relay-entries-card'>
            <DataGrid
                className='relay-entries-grid'
                dataSource={gridData}
                remoteOperations={true}
                width={'100%'}
                height={'calc(100vh - 250px)'}
                rowAlternationEnabled={true}
                onExporting={onExporting}
                ref={gridRef}
                onCellClick={onCellClick}
                onRowRemoving={(e) => {
                    const entryRelayId = e.data.entryRelayId; // ID des gelöschten Eintrags
                    if (entryRelayId) {
                        DeleteEntryRelay(entryRelayId); // Lösche den Eintrag
                    }
                    e.cancel = true; // Verhindere das Löschen der Zeile in der Tabelle
                }}
            //  columnAutoWidth={useScreenSize() === 'xs'}
            >
                <Export enabled formats={exportFormats} />
                <Paging enabled={false} />

                <Editing mode="cell" allowAdding={false} allowDeleting={checkPermission('entry.delete')} allowUpdating={false} />
                <Toolbar>
                    <Item location='before'>
                        <Button
                            icon='plus'
                            type='default'
                            stylingMode='contained'
                            onClick={onInsertEntryClick}
                        />
                    </Item>



                </Toolbar>

                <Column dataField="name" caption="Schwimmstil" width={120} allowEditing={false} fixed={true} cellRender={(cellData) => (
                    <span style={{ fontWeight: 'bold' }}>{cellData.value}</span>
                )} />
                  <Column dataField="clubname" caption="Verein" width={120} allowEditing={false} />
                <Column dataField="entrytime" caption="Meldezeit" dataType="number" width={80} cellRender={TimeBoxBold} allowEditing={false} />
                <Column dataField="number" caption="WK-Nr." width={100} allowEditing={false} />
                <Column dataField="gender" caption="Geschlecht" dataType='number' width={100} allowEditing={false} lookup={{ dataSource: GENDERS, valueExpr: 'id', displayExpr: 'text' }} />
                <Column dataField="eventorder" caption="Reihenfolge" visible={false} allowEditing={false} sortOrder='asc' sortIndex={0} />
                <Column
                    dataField='status'
                    caption='Status'
                    dataType='string'
                    width={isXSmall ? 50 : null}
                    hidingPriority={3}
                    cellRender={CompetitionAthleteStatus}
                />
                <Summary>
                    <TotalItem
                        column="entrytime"
                        summaryType="count"
                        displayFormat="Meldungen: {0}" />
                </Summary>

            </DataGrid>
            <FormEntryPopup title='Meldungen bearbeiten' width={900} height={'calc(100vh - 160px)'} visible={popupEntryRelayVisible} setVisible={changePopupEntryRelayVisibility} isSaveVisible={competition?.status === 'Meldung möglich'} onSave={saveEntryRelay} saveWithoutClosing={true} >
                <EntryRelayFormWithLoadPanel hasData={true} loading={false} onDataChanged={onDataChanged} initData={entryData} allowEditing={competition?.status === 'Meldung möglich'} athletes={athletes}/>
            </FormEntryPopup>

        </div>
    );
};

const GridWithLoadPanel = withLoadPanel(Grid);

export const CardEntriesRelay = ({ EntriesRelay, isLoading, competitionId, athletes, competition }) => {
    
    return (
        <div className='card-relay-entries'>
            <GridWithLoadPanel
                EntriesRelay={EntriesRelay}
                hasData={!!EntriesRelay}
                loading={isLoading}
                athletes={athletes}
                competitionId={competitionId}
                competition={competition}
                panelProps={{
                    container: '.card-relay-entries',
                    position: { of: '.card-relay-entries' }
                }}
            />
        </div>
    );
};


